import TokensService from '@omni/kit/services/TokensService';

import BaseService, { IHttpResponse, IUri } from '../../BaseService';
import { prepareUrl } from '../BuildUrls';
import { IOpenChannelsParticipants } from '../Types';

const RESOURCE = 'open-channel-participants';

interface IGetOpenChannelParticipants extends Omit<IUri, 'resource'> {
  appKey: string;
}

interface IGetOpenChannelParticipantsResponse extends IHttpResponse {
  body?: IOpenChannelsParticipants;
}

export default async ({
  appKey,
  ...buildUrlProps
}: IGetOpenChannelParticipants): Promise<IGetOpenChannelParticipantsResponse> => {
  const url = prepareUrl({
    ...buildUrlProps,
    resource: RESOURCE,
  });

  const guestToken = await TokensService.getGuestToken();

  return BaseService.Get({ url, appKey, token: guestToken });
};
